<div class="player-container">
  <div *ngIf="isFreeSpaceClickable" class="clickable-side" (click)="onFreeSpaceClicked()"></div>
  <iframe class="player" allow="fullscreen" [src]="getUrlVideo(drone) | safe : 'resourceUrl'"> </iframe>
</div>
